import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex flex-col">
      <div className="relative w-full px-6 md:px-10 pt-32 md:pt-40 pb-10 flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
        <div className="flex-1 lg:w-1/2">
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-950 leading-[1.08] tracking-tight">
            Mulebuy Spreadsheet
            <br />
            <span className="text-primary-500">The Ultimate Guide</span>
            <br />
            to Smarter Cross-Border Shopping
          </h1>
          <p className="mt-6 text-base md:text-lg text-foreground-600 max-w-lg leading-relaxed">
            Discover how the Mulebuy Spreadsheet system helps global buyers source products faster, compare prices easily, and simplify cross-border shopping workflows — all in one organized system.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold cursor-pointer hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
            >
              Get Started with Mulebuy Spreadsheet
            </a>
            <button
              type="button"
              onClick={() => navigate('/what-is-mulebuy-spreadsheet')}
              className="flex items-center gap-2 px-6 py-3.5 rounded-full border border-foreground-300/50 text-foreground-700 text-sm font-medium cursor-pointer hover:border-foreground-500 hover:text-foreground-950 transition-all duration-200 whitespace-nowrap"
            >
              <span>Explore the Full Guide</span>
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </button>
          </div>
        </div>

        <div className="flex-1 lg:w-1/2 flex flex-col gap-5">
          <p className="text-sm text-foreground-500 leading-relaxed max-w-md">
            Whether you are a beginner exploring cross-border shopping or an experienced buyer optimizing your workflow, the Mulebuy Spreadsheet approach transforms how you manage products, compare suppliers, and make smarter purchasing decisions.
          </p>
          <a
            href="/what-is-mulebuy-spreadsheet"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200"
          >
            <span>Read the complete guide</span>
            <span className="w-5 h-5 bg-foreground-950 rounded-full flex items-center justify-center">
              <i className="ri-arrow-right-line text-background-50 text-xs"></i>
            </span>
          </a>
        </div>
      </div>

      <div className="w-full px-6 md:px-10 pb-10 md:pb-14">
        <div className="w-full h-[350px] md:h-[420px] rounded-3xl overflow-hidden relative">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20and%20lifestyle%20product%20flatlay%20featuring%20designer%20sneakers%20leather%20handbags%20minimalist%20watches%20and%20premium%20accessories%20artfully%20scattered%20on%20warm%20sand-colored%20linen%20fabric%20surface%2C%20soft%20diffused%20morning%20light%20from%20large%20window%2C%20editorial%20product%20photography%20with%20gentle%20shadows%2C%20natural%20neutral%20earth%20tones%2C%20aspirational%20modern%20lifestyle%20aesthetic%2C%20harmonious%20composition%20with%20organic%20spacing&width=1800&height=840&seq=hero-main-v2-001&orientation=landscape"
            alt="Mulebuy Spreadsheet cross-border shopping guide with fashion products flatlay"
            title="Mulebuy Spreadsheet - Cross-Border Shopping Guide"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}